import { render, staticRenderFns } from "./goFixTables.vue?vue&type=template&id=6800fe80&"
import script from "./goFixTables.vue?vue&type=script&lang=js&"
export * from "./goFixTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports